import { useState, useEffect } from "react";
import useFetch from "Hooks/useFetch.js";
import Spinner from "Components/RequestHandler/Spinner";

const TrainingMaterial = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("training-material");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section className="col-span-3 map">
      <h1 className="text-3xl font-bold text-white uppercase mb-4">
        Training Material
      </h1>

      <div className="flex flex-col gap-y-24">
        {isLoading ? (
          <div>
            <Spinner />
            <p className="capitalize text-white mt-2">Loading data...</p>
          </div>
        ) : (
          data?.map(({ name, image, text, link, pdf, video }, index) => (
            <div key={index}>
              {video ? (
                <video
                  controls
                  className="w-auto h-auto"
                  src={video}
                  alt={`Video for ${name}`}
                />
              ) : (
                image && (
                  <img
                    src={image}
                    alt={`for ${name}`}
                    className="w-auto h-auto"
                  />
                )
              )}

              <div className="text-white mt-4">
                <h4 className="text-4xl capitalize">{name}</h4>

                <div
                  className="text-xl mt-2"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </div>

              <div className="py-4 px-8 bg-[#222] mt-4 text-xl text-white">
                {link && (
                  <a
                    rel="noreferrer"
                    className="capitalize hover:underline"
                    target="_blank"
                    href={link}
                  >
                    check the link here
                  </a>
                )}
                {pdf && (
                  <a
                    href={pdf}
                    download
                    className="capitalize hover:underline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download PDF
                  </a>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default TrainingMaterial;
